import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class PopoverElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title = 'Title';
  subtitle = '';
  content =
    'Lorem ipsum dolor sit amet, ius prima partem postulant te, sed an omittam oportere. Eos detraxit tractatos forensibus id, eu nostrum maluisset eam. Ea agam graeci electram vel, ei quidam cetero sit.';
  src: string;
  buttonText: string;
  link = new TbLink();
  top = 40;
  left = 50;

  constructor(src?: string) {
    this.src = src;
  }

  static normalizeInPlace(element: PopoverElement): PopoverElement {
    const pureElement = new PopoverElement();

    element.title = element.title ?? pureElement.title;
    element.subtitle = element.subtitle ?? pureElement.subtitle;
    element.content = element.content ?? pureElement.content;
    element.src = element.src ?? pureElement.src;
    element.buttonText = element.buttonText ?? pureElement.buttonText;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);
    element.top = element.top ?? pureElement.top;
    element.left = element.left ?? pureElement.left;

    return element;
  }
}
